import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/gradient-background.svg")